export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q05_a.ca60beea.png";